export default __webpack_public_path__ + "static/media/1.660bf65d.jpg";